import { OptionalComponent } from './optional/optional.component';
import { IonicModule } from '@ionic/angular';
import { PinCodeComponent } from './pin-code/pin-code.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EnterPinComponent } from './enter-pin/enter-pin.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [PinCodeComponent, EnterPinComponent, OptionalComponent],
  exports: [PinCodeComponent],
  imports: [CommonModule, IonicModule, TranslateModule, AngularSvgIconModule],
})
export class PinCodeModule {}
